import { popoverMotion } from "../../../design-system/tokens/popoverMotion";
import styled from "styled-components";
import { borderRadius } from "../../../design-system/tokens/borders";
import { rawColors } from "../../../design-system/tokens/colors";
import { shadows, zIndex } from "../../../design-system/tokens/shadows";

/**
 * Floating shell for the header + body. Position, width and max height come
 * from the caller's rect (inline, as every portal menu here does). Figma draws
 * the two halves only, so the outer popover shadow is the design system's.
 */
export const Card = styled.div`
  position: fixed;
  ${popoverMotion()}
  z-index: ${zIndex.popover};
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  background: ${rawColors.structural.white};
  border-radius: ${borderRadius.xl};
  box-shadow: ${shadows.component.popover};
`;
